module.exports = __webpack_public_path__ + "media/vo-01-03.97ba0da2.mp3";